var map = {
	"./adidas.jpg": 20534,
	"./adidas.png": 67680,
	"./brand-icon-01.png": 87300,
	"./brand-icon-02.png": 44273,
	"./brand-icon-03.png": 97355,
	"./brand-icon-04.png": 89774,
	"./brand-icon-05.png": 59701,
	"./brand-icon-06.png": 70707,
	"./brand-icon-07.png": 56800,
	"./brand-icon-08.png": 42739,
	"./brand-icon-09.png": 41062,
	"./brand-icon-10.png": 20556,
	"./colgate.png": 63361,
	"./samsung.png": 63962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2678;